import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CosmicBackground, SiteHeader, SiteFooter, PrivacyDialog } from "@/components/landing/chrome";
import { HeroSection, MarqueeStrip } from "@/components/landing/hero";
import { PillarsSection, CoverageBand, PartnerSection } from "@/components/landing/sections";
import { FormsSection } from "@/components/landing/forms";
import AdminPage from "@/pages/AdminPage";

function LandingPage() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const openPrivacy = () => setPrivacyOpen(true);
  const closePrivacy = () => setPrivacyOpen(false);

  return (
    <div className="text-slate-100 min-h-screen relative overflow-x-hidden" data-testid="landing-page">
      <CosmicBackground />
      <SiteHeader />
      <main className="relative z-10">
        <HeroSection />
        <MarqueeStrip />
        <PillarsSection />
        <CoverageBand />
        <FormsSection onOpenPrivacy={openPrivacy} />
        <PartnerSection />
      </main>
      <SiteFooter onPrivacy={openPrivacy} />
      <PrivacyDialog open={privacyOpen} onClose={closePrivacy} />
      <Toaster theme="dark" position="bottom-right" richColors closeButton />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
